import {
  BA_EMAIL,
  BA_FIRST_NAME,
  BA_LAST_MISSION_DATE,
  BA_LAST_MISSION_TIME,
  BA_LAST_NAME,
  BA_MONEY_EARNED,
  BA_NEXT_MISSION_DATE,
  BA_NEXT_MISSION_TIME,
  BA_NEXT_MISSION_TYPE,
  BA_NEXT_MISSION_LOCATION,
  BA_NEXT_MISSION_CLIENT,
  BA_NEXT_MISSION_PAY_RATIO,
  BA_ONBOARDING_DATE,
  BA_ONBOARDING_TIME,
  BA_PHONE,
  BA_SIGNUP_DATE,
  BA_STATUS,
  BA_MERCHANDISE_HELD,
  BA_BLOCKED_REASON,
  CITY_BA_ONBOARDING_LINK,
  CITY_BA_REFERRAL_REWARD,
  CITY_BA_REFERRAL_START_DATE,
  CITY_BA_REFERRAL_TRIGGER,
  CITY_BAD_WEATHER_PAYOUT,
  CITY_BAD_WEATHER_WEEK,
  CITY_BAD_WEATHER_WEEK_TARGET,
  CITY_MISSION_AVAILABLE,
  CITY_NAME,
  CITY_NEXT_PICKUP_DATE,
  CITY_NEXT_PICKUP_TIME,
  CITY_PICKUP_LOCATION_LINK,
  DEEPLINK_ABN,
  DEEPLINK_APP_STORE,
  DEEPLINK_APP_UPDATE,
  DEEPLINK_AVAILABILITY,
  DEEPLINK_BANK_DETAILS,
  DEEPLINK_BOOK_MISSION,
  DEEPLINK_COMPLETED_MISSIONS,
  DEEPLINK_CONTACT_DETAILS,
  DEEPLINK_EARNINGS,
  DEEPLINK_HOW_TO_GUIDE,
  DEEPLINK_MISSION_CHECKIN,
  DEEPLINK_PAUSE_AVAILABILITY,
  DEEPLINK_PRIVACY_POLICY,
  DEEPLINK_SET_BASES,
  DEEPLINK_SURGE_TIME,
  DEEPLINK_TERMS_OF_SERVICE,
  DEEPLINK_UPCOMING_MISSION,
  DEEPLINK_UPLOAD_PICTURE,
  DEEPLINK_PICKUP_LOCATION,
  DEEPLINK_PICKUP_TIME,
  DEEPLINK_CLIENT_PITCH,
  DEEPLINK_MISSION_LOCATION,
  DEEPLINK_PAYMENT_DATE,
  DEEPLINK_REFER_FRIEND,
  DEEPLINK_PICKUP_SCANNER,
  DEEPLINK_CHAT,
  DEEPLINK_MY_MISSIONS,
  PLACEHOLDER_LABELS,
  DEEPLINK_BROWSE_MISSIONS_H2H,
  DEEPLINK_BROWSE_MISSIONS_LTB,
  DEEPLINK_MY_COMPLETED_MISSIONS,
  DEEPLINK_REBOOK_ONBOARDING,
  BA_MISSION_MEETING_POINT_TIME,
  BA_MISSION_MEETING_POINT_DATE,
  BA_MISSION_MEETING_POINT_ADDRESS,
} from '../../../../../shared/constants'

const PIPELINE_STAGE_ENUM = {
  UNINTERESTED: 'uninterested',
  INTERESTED: 'interested',
  BOOKED: 'booked',
  BLOCKED: 'refused',
  ON_SITE_TRAINING: 'onSiteTraining',
  PRE_ACCESS: 'preAccess',
  WAITING_FOR_REVIEW: 'finalReview',
  ONSITE_MEETING: 'onsiteMeeting',
  APPROVED: 'approved',
  TEST: 'test',
}

const PIPELINE_EMAILS_STEPS_ENUM = {
  SEQUENCES_VIEW: 'sequences',
  SEQUENCE_STATS: 'stats',
  SEQUENCE_EDIT: 'edit',
  SEQUENCE_CREATE: 'create',
}

const mocRowsSequence = [
  {
    date: '11/12/2022',
    owner: 'Dima',
    nameSequence: 'Test sequence',
    status: 'Active/Sequence ended',
    openCount: 11,
    clickCount: 15,
  },
  {
    date: '11/12/2022',
    owner: 'Dima',
    nameSequence: 'Test sequence',
    status: 'Active/Sequence ended',
    openCount: 11,
    clickCount: 15,
  },
  {
    date: '11/12/2022',
    owner: 'Dima',
    nameSequence: 'Test sequence',
    status: 'Active/Sequence ended',
    openCount: 11,
    clickCount: 15,
  },
  {
    date: '11/12/2022',
    owner: 'Dima',
    nameSequence: 'Test sequence',
    status: 'Active/Sequence ended',
    openCount: 11,
    clickCount: 15,
  },
]

const mocRowsEnrolments = [
  {
    date: '11/12/2022',
    baName: 'Arthur Favier',
    stepName: 'Name_message',
    status: 'Opened',
    pipelineStage: 'Interested',
    openCount: 11,
    clickCount: 15,
  },
  {
    date: '11/12/2022',
    baName: 'Arthur Favier',
    stepName: 'Name_message',
    status: 'Opened',
    pipelineStage: 'Interested',
    openCount: 11,
    clickCount: 15,
  },
  {
    date: '11/12/2022',
    baName: 'Arthur Favier',
    stepName: 'Name_message',
    status: 'Opened',
    pipelineStage: 'Interested',
    openCount: 11,
    clickCount: 15,
  },
]
const headersEnrollments = [
  {
    id: 'sent',
    disablePadding: false,
    label: 'Email sent date',
    sortable: true,
    alwaysShowSortIcon: true,
  },
  {
    id: 'name',
    disablePadding: false,
    label: 'BA Name',
    sortable: true,
    alwaysShowSortIcon: true,
  },
  {
    id: 'state',
    disablePadding: false,
    label: 'Status',
    sortable: false,
  },
  {
    id: 'emailName',
    disablePadding: false,
    label: 'Step name',
    sortable: true,
    alwaysShowSortIcon: true,
  },
  {
    id: 'pipelineStage',
    disablePadding: false,
    label: 'Pipeline Stage',
    sortable: false,
  },
  {
    id: 'open',
    disablePadding: false,
    label: 'Open',
    sortable: true,
    alwaysShowSortIcon: true,
  },
  {
    id: 'click',
    disablePadding: false,
    label: 'Clicks',
    sortable: true,
    alwaysShowSortIcon: true,
  },
  {
    id: 'actions',
    disablePadding: false,
    label: 'Actions',
    sortable: false,
  },
]

const headersSequence = [
  {
    id: 'date',
    disablePadding: false,
    label: 'Created Date',
    sortable: false,
  },
  {
    id: 'owner',
    disablePadding: false,
    label: 'Owner',
    sortable: false,
  },
  {
    id: 'nameSequence',
    disablePadding: false,
    label: 'Sequence Name',
    sortable: false,
  },
  {
    id: 'stage',
    disablePadding: false,
    label: 'Stage',
    sortable: false,
  },
  {
    id: 'numberOfComms',
    disablePadding: false,
    label: '# of comms',
    sortable: false,
  },
  {
    id: 'typeOfComms',
    disablePadding: false,
    label: 'Type of comms',
    sortable: false,
  },
  {
    id: 'seqLength',
    disablePadding: false,
    label: 'Length',
    sortable: false,
  },
  {
    id: 'sentCount',
    disablePadding: false,
    label: 'Sent',
    sortable: false,
  },
  {
    id: 'openCount',
    disablePadding: false,
    label: 'Open',
    sortable: false,
  },
  {
    id: 'clickCount',
    disablePadding: false,
    label: 'Clicks',
    sortable: false,
  },
  {
    id: 'openRate',
    disablePadding: false,
    label: 'Open Rate',
    sortable: false,
  },
  {
    id: 'clickRate',
    disablePadding: false,
    label: 'Click Rate',
    sortable: false,
  },
  {
    id: 'actions',
    disablePadding: false,
    label: 'Actions',
    sortable: false,
  },
]

const headersCommunications = [
  {
    id: 'name',
    disablePadding: false,
    label: 'Name',
    sortable: false,
  },
  {
    id: 'type',
    disablePadding: false,
    label: 'Type',
    sortable: false,
  },
  {
    id: 'commDelay',
    disablePadding: false,
    label: 'Delay',
    sortable: false,
  },
  {
    id: 'sentCount',
    disablePadding: false,
    label: 'Sent',
    sortable: false,
  },
  {
    id: 'openCount',
    disablePadding: false,
    label: 'Open',
    sortable: false,
  },
  {
    id: 'clickCount',
    disablePadding: false,
    label: 'Clicks',
    sortable: false,
  },
  {
    id: 'openRate',
    disablePadding: false,
    label: 'Open Rate',
    sortable: false,
  },
  {
    id: 'clickRate',
    disablePadding: false,
    label: 'Click Rate',
    sortable: false,
  },
]

const optionsStages = [
  { value: 'uninterested', label: 'Uninterested' },
  { value: 'interested', label: 'Interested' },
  { value: 'booked', label: 'Booked' },
  { value: 'videoOnboarding', label: 'Video Onboarding' },
  { value: 'quiz', label: 'Test' },
  { value: 'refused', label: 'Blocked' },
  { value: 'onSiteTraining', label: 'Onsite training' },
  { value: 'preAccess', label: 'Pre access' },
  { value: 'finalReview', label: 'Waiting for review' },
  { value: 'onsiteMeeting', label: 'Onsite meeting' },
  { value: 'approved', label: 'Approved' },
  { value: 'all', label: 'All' },
]

const communicationsOptions = [
  { value: 'all', label: 'All' },
  { value: 'email', label: 'Email' },
  { value: 'notification', label: 'Push notification' },
  { value: 'sms', label: 'SMS' },
]

const sequencesSourceOptions = [
  { value: 'all', label: 'All' },
  { value: 'editable', label: 'Ops-made' },
  { value: 'hardcoded', label: 'Hardcoded' },
]

const sequencesTypeOptions = [
  { value: 'all', label: 'All' },
  { value: 'schedule', label: 'Schedule driven' },
  { value: 'trigger', label: 'Trigger driven' },
]

const stagesMapper = new Map([
  ['uninterested', 'Uninterested'],
  ['interested', 'Interested'],
  ['videoOnboarding', 'Video Onboarding'],
  ['booked', 'Booked'],
  ['refused', 'Blocked'],
  ['onSiteTraining', 'Onsite training'],
  ['preAccess', 'Pre access'],
  ['finalReview', 'Waiting for review'],
  ['onsiteMeeting', 'Onsite meeting'],
  ['approved', 'Approved'],
  ['quiz', 'Test'],
])

const optionsStatuses = [
  { value: 'all', label: 'All' },
  { value: 'clicked', label: 'Clicked' },
  { value: 'opened', label: 'Opened' },
  { value: 'notOpened', label: 'Not opened' },
  { value: 'notDelivered', label: 'Not delivered' },
]

const optionsGroupBy = [
  { value: 'ALL', label: 'All' },
  { value: 'bas', label: 'BAs' },
  { value: 'steps', label: 'Steps' },
]

const conditionalTriggers = [
  'Missions completed',
  'BA Rating (7) H2H',
  'BA Rating (30) H2H',
  'BA Rating (7) Letterbox',
  'BA Rating (30) Letterbox',
  'BA distributed N flyers',
]

const scheduledTriggers = [
  'Time before next pickup date',
  'Time before next mission',
  'Before next onboarding start',
]

const optionsRedirection = [
  {
    id: 'Session booking screen',
    value: 'bookInterview',
    label: 'Session booking screen',
    stages: [PIPELINE_STAGE_ENUM.INTERESTED, PIPELINE_STAGE_ENUM.BOOKED],
  },
  {
    id: 'Reschedule session screen',
    value: 'reBookInterview',
    label: 'Reschedule session screen',
    stages: [PIPELINE_STAGE_ENUM.BOOKED],
  },
  {
    id: 'My profile',
    value: 'myProfile',
    label: 'My profile',
    stages: [PIPELINE_STAGE_ENUM.APPROVED],
  },

  {
    id: 'Browse missions',
    value: 'browseMissions',
    label: 'Browse missions',
    stages: [PIPELINE_STAGE_ENUM.APPROVED],
  },

  {
    id: 'Upcoming missions',
    value: 'myMissions',
    label: 'Upcoming missions',
    stages: [PIPELINE_STAGE_ENUM.APPROVED],
  },

  {
    id: 'Settings',
    value: 'settings',
    label: 'Settings',
    stages: [PIPELINE_STAGE_ENUM.APPROVED],
  },
  {
    id: 'Pickup scanner page',
    value: 'pickup',
    label: 'Pickup scanner page',
    stages: [PIPELINE_STAGE_ENUM.APPROVED],
  },
  {
    id: 'Open the app',
    value: 'openApp',
    label: 'Open the app',
    stages: [
      PIPELINE_STAGE_ENUM.APPROVED,
      PIPELINE_STAGE_ENUM.BLOCKED,
      PIPELINE_STAGE_ENUM.INTERESTED,
      PIPELINE_STAGE_ENUM.PRE_ACCESS,
      PIPELINE_STAGE_ENUM.ON_SITE_TRAINING,
      PIPELINE_STAGE_ENUM.WAITING_FOR_REVIEW,
      PIPELINE_STAGE_ENUM.BOOKED,
      PIPELINE_STAGE_ENUM.UNINTERESTED,
    ],
  },
]

const optionsTriggers = [
  {
    id: 'City related triggers',
    label: 'City related triggers',
    isSubHead: true,
    stages: [PIPELINE_STAGE_ENUM.APPROVED],
  },
  {
    id: 'BA referral active',
    value: 'BA referral active',
    label: 'BA referral active',
    isSubHead: false,
    stages: [PIPELINE_STAGE_ENUM.APPROVED],
  },
  {
    id: 'Pick up date',
    value: 'Pick up date',
    label: 'Next pickup date',
    isSubHead: false,
    stages: [],
  },
  {
    id: 'Bad weather surge',
    value: 'Bad weather surge',
    label: 'Weekly surge created',
    isSubHead: false,
    stages: [PIPELINE_STAGE_ENUM.APPROVED],
  },
  {
    id: 'Mission related triggers',
    label: 'Mission related triggers',
    isSubHead: true,
    stages: [PIPELINE_STAGE_ENUM.APPROVED],
  },
  {
    id: 'Mission canceled by Admin',
    value: 'Mission canceled by Admin',
    label: 'Mission canceled by Admin',
    isSubHead: false,
    stages: [PIPELINE_STAGE_ENUM.APPROVED],
  },
  {
    id: 'Mission canceled by BA',
    value: 'Mission canceled by BA',
    label: 'Mission canceled by BA',
    isSubHead: false,
    stages: [PIPELINE_STAGE_ENUM.APPROVED],
  },
  {
    id: 'Pay ratio changed',
    value: 'Pay ratio changed',
    label: 'Pay ratio changed',
    isSubHead: false,
    stages: [PIPELINE_STAGE_ENUM.APPROVED],
  },
  {
    id: 'BA related triggers',
    label: 'BA related triggers',
    isSubHead: true,
    stages: [
      PIPELINE_STAGE_ENUM.UNINTERESTED,
      PIPELINE_STAGE_ENUM.INTERESTED,
      PIPELINE_STAGE_ENUM.BOOKED,
      PIPELINE_STAGE_ENUM.ON_SITE_TRAINING,
      PIPELINE_STAGE_ENUM.PRE_ACCESS,
      PIPELINE_STAGE_ENUM.FINAL_REVIEW,
      PIPELINE_STAGE_ENUM.ONSITE_MEETING,
      PIPELINE_STAGE_ENUM.APPROVED,
      PIPELINE_STAGE_ENUM.BLOCKED,
    ],
  },
  {
    id: 'BA Blocked',
    value: 'BA Blocked',
    label: 'BA Blocked',
    isSubHead: false,
    stages: [PIPELINE_STAGE_ENUM.BLOCKED],
  },
  {
    id: 'First time approved BA',
    value: 'First time approved BA',
    label: `BA enters 'Approved' first time`,
    isSubHead: false,
    stages: [PIPELINE_STAGE_ENUM.APPROVED],
  },
  {
    id: 'BA enters Pre Access',
    value: 'BA enters Pre Access',
    label: `BA enters 'Pre Access'`,
    isSubHead: false,
    stages: [PIPELINE_STAGE_ENUM.PRE_ACCESS],
  },
  {
    id: 'BA enters Onsite training',
    value: 'BA enters Onsite training',
    label: `BA enters 'Onsite training'`,
    isSubHead: false,
    stages: [PIPELINE_STAGE_ENUM.ON_SITE_TRAINING],
  },
  {
    id: 'BA enters Waiting for Review',
    value: 'BA enters Waiting for Review',
    label: `BA enters 'Waiting For Review'`,
    isSubHead: false,
    stages: [PIPELINE_STAGE_ENUM.WAITING_FOR_REVIEW],
  },
  {
    id: 'BA enters Onsite Meeting',
    value: 'BA enters Onsite Meeting',
    label: `BA enters 'Onsite Meeting'`,
    isSubHead: false,
    stages: [PIPELINE_STAGE_ENUM.ONSITE_MEETING],
  },
  {
    id: 'BA got the first conversion',
    value: 'BA got the first conversion',
    label: "BA's first conversion in campaign",
    isSubHead: false,
    stages: [PIPELINE_STAGE_ENUM.APPROVED],
  },
  {
    id: 'BA missed allowed check-in window',
    value: 'BA missed allowed check-in window',
    label: 'BA missed allowed check-in window',
    isSubHead: false,
    stages: [PIPELINE_STAGE_ENUM.APPROVED],
  },
  {
    id: 'BA missed surge check-in window',
    value: 'BA missed surge check-in window',
    label: 'BA missed surge check-in window',
    isSubHead: false,
    stages: [PIPELINE_STAGE_ENUM.APPROVED],
  },
  {
    id: 'Signup date',
    value: 'Signup date',
    label: 'BA signed up',
    isSubHead: false,
    stages: [],
  },
  {
    id: 'BA distributed N flyers',
    value: 'BA distributed N flyers',
    label: `Distributed flyers`,
    isSubHead: false,
    stages: [PIPELINE_STAGE_ENUM.APPROVED],
  },
  // Moved to V2
  // {
  //   id: 'Business number not completed',
  //   value: 'Business number not completed',
  //   label: 'Business number not completed',
  //   isSubHead: false,
  //   stages: [PIPELINE_STAGE_ENUM.APPROVED],
  // },
  {
    id: 'First mission ever booked',
    value: 'First mission ever booked',
    label: 'First mission booked',
    isSubHead: false,
    stages: [PIPELINE_STAGE_ENUM.APPROVED],
  },
  {
    id: 'First ever mission completed',
    value: 'First ever mission completed',
    label: 'First ever mission completed',
    isSubHead: false,
    stages: [PIPELINE_STAGE_ENUM.APPROVED],
  },
  {
    id: 'Mission booked',
    value: 'Mission booked',
    label: 'Mission booked',
    isSubHead: false,
    stages: [PIPELINE_STAGE_ENUM.APPROVED],
  },
  {
    id: 'Missions completed',
    value: 'Missions completed',
    label: 'Missions completed',
    isSubHead: false,
    stages: [PIPELINE_STAGE_ENUM.APPROVED],
  },
  {
    id: 'Mission type D2D only',
    value: 'Mission type D2D only',
    label: 'Mission type D2D only',
    isSubHead: false,
    stages: [PIPELINE_STAGE_ENUM.APPROVED],
  },
  {
    id: 'Mission type H2H only',
    value: 'Mission type H2H only',
    label: 'Mission type H2H only',
    isSubHead: false,
    stages: [PIPELINE_STAGE_ENUM.APPROVED],
  },
  {
    id: 'Moved to Uninterested',
    value: 'Moved to Uninterested',
    label: 'Moved to Uninterested',
    isSubHead: false,
    stages: [PIPELINE_STAGE_ENUM.UNINTERESTED],
  },
  {
    id: 'Onboarding booked',
    value: 'Onboarding booked',
    label: 'Onboarding booked',
    isSubHead: false,
    stages: [PIPELINE_STAGE_ENUM.BOOKED],
  },
  {
    id: 'Onboarding canceled',
    value: 'Onboarding canceled',
    label: 'Onboarding canceled',
    isSubHead: false,
    stages: [PIPELINE_STAGE_ENUM.INTERESTED],
  },
  {
    id: 'Onboarding rescheduled',
    value: 'Onboarding rescheduled',
    label: 'Onboarding rescheduled',
    isSubHead: false,
    stages: [PIPELINE_STAGE_ENUM.BOOKED],
  },
  // Moved to V2
  // {
  //   id: 'Signup documents not provided',
  //   value: 'Signup documents not provided',
  //   label: 'Signup documents not provided',
  //   isSubHead: false,
  //   stages: [PIPELINE_STAGE_ENUM.APPROVED],
  // },
  {
    id: 'BA referral complete',
    value: 'BA referral complete',
    label: `Referral completed`,
    isSubHead: false,
    stages: [PIPELINE_STAGE_ENUM.APPROVED],
  },
  {
    id: 'Withhold payment active',
    value: 'Withhold payment active',
    label: 'Withhold payment active',
    isSubHead: false,
    stages: [PIPELINE_STAGE_ENUM.APPROVED],
  },
  {
    id: 'Reminder triggers',
    label: 'Reminder triggers',
    isSubHead: true,
    stages: [PIPELINE_STAGE_ENUM.APPROVED, PIPELINE_STAGE_ENUM.BOOKED],
  },
  {
    id: 'Time before next pickup date',
    value: 'Time before next pickup date',
    label: 'Next booked pickup time',
    isSubHead: false,
    stages: [PIPELINE_STAGE_ENUM.APPROVED],
  },
  {
    id: 'Time before next mission',
    value: 'Time before next mission',
    label: 'Next mission start time',
    isSubHead: false,
    stages: [PIPELINE_STAGE_ENUM.APPROVED],
  },
  {
    id: 'Before next onboarding start',
    value: 'Before next onboarding start',
    label: 'Next onboarding start time',
    isSubHead: false,
    stages: [PIPELINE_STAGE_ENUM.BOOKED],
  },
  {
    id: 'Spy feedback related triggers',
    label: 'Spy feedback related triggers',
    isSubHead: true,
    stages: [PIPELINE_STAGE_ENUM.APPROVED],
  },
  {
    id: 'BA disappeared and not reachable',
    value: 'BA disappeared and not reachable',
    label: 'BA disappeared and not reachable',
    isSubHead: false,
    stages: [PIPELINE_STAGE_ENUM.APPROVED],
  },
  {
    id: 'BA engaging with crowd',
    value: 'BA engaging with crowd',
    label: 'BA engaging with crowd',
    isSubHead: false,
    stages: [PIPELINE_STAGE_ENUM.APPROVED],
  },
  {
    id: 'BA finished all flyers',
    value: 'BA finished all flyers',
    label: 'BA finished all flyers',
    isSubHead: false,
    stages: [PIPELINE_STAGE_ENUM.APPROVED],
  },
  {
    id: 'BA refuse listening',
    value: 'BA refuse listening',
    label: 'BA refuse listening',
    isSubHead: false,
    stages: [PIPELINE_STAGE_ENUM.APPROVED],
  },
  {
    id: 'BA throwing away flyers',
    value: 'BA throwing away flyers',
    label: 'BA throwing away flyers',
    isSubHead: false,
    stages: [PIPELINE_STAGE_ENUM.APPROVED],
  },
  {
    id: 'Bad location',
    value: 'Bad location',
    label: 'Bad location',
    isSubHead: false,
    stages: [PIPELINE_STAGE_ENUM.APPROVED],
  },
  {
    id: 'Client pitch known',
    value: 'Client pitch known',
    label: 'Client pitch known',
    isSubHead: false,
    stages: [PIPELINE_STAGE_ENUM.APPROVED],
  },
  {
    id: 'Distribution below 3F/min',
    value: 'Distribution below 3F/min',
    label: 'Distribution below 3F/min',
    isSubHead: false,
    stages: [PIPELINE_STAGE_ENUM.APPROVED],
  },
  {
    id: 'Distribution by 2 and more',
    value: 'Distribution by 2 and more',
    label: 'Distribution by 2 and more',
    isSubHead: false,
    stages: [PIPELINE_STAGE_ENUM.APPROVED],
  },
  {
    id: 'Distribution over 5F/min',
    value: 'Distribution over 5F/min',
    label: 'Distribution over 5F/min',
    isSubHead: false,
    stages: [PIPELINE_STAGE_ENUM.APPROVED],
  },
  {
    id: 'Distribution between 3-5F/min',
    value: 'Distribution between 3-5F/min',
    label: 'Distribution between 3-5F/min',
    isSubHead: false,
    stages: [PIPELINE_STAGE_ENUM.APPROVED],
  },
  {
    id: 'High traffic location',
    value: 'High traffic location',
    label: 'High traffic location',
    isSubHead: false,
    stages: [PIPELINE_STAGE_ENUM.APPROVED],
  },
  {
    id: 'No uniform',
    value: 'No uniform',
    label: 'No uniform',
    isSubHead: false,
    stages: [PIPELINE_STAGE_ENUM.APPROVED],
  },
  {
    id: 'Obedient BA',
    value: 'Obedient BA',
    label: 'Obedient BA',
    isSubHead: false,
    stages: [PIPELINE_STAGE_ENUM.APPROVED],
  },
  {
    id: 'Passive BA',
    value: 'Passive BA',
    label: 'Passive BA',
    isSubHead: false,
    stages: [PIPELINE_STAGE_ENUM.APPROVED],
  },
  {
    id: 'Proactive BA',
    value: 'Proactive BA',
    label: 'Proactive BA',
    isSubHead: false,
    stages: [PIPELINE_STAGE_ENUM.APPROVED],
  },
  {
    id: 'Training needed for BA',
    value: 'Training needed for BA',
    label: 'Training needed for BA',
    isSubHead: false,
    stages: [PIPELINE_STAGE_ENUM.APPROVED],
  },
]

const baRelatedPlaceholders = [
  {
    id: BA_FIRST_NAME,
    value: BA_FIRST_NAME,
    label: PLACEHOLDER_LABELS.BA_FIRST_NAME,
    isSubHead: false,
  },
  {
    id: BA_LAST_NAME,
    value: BA_LAST_NAME,
    label: PLACEHOLDER_LABELS.BA_LAST_NAME,
    isSubHead: false,
  },
  {
    id: BA_EMAIL,
    value: BA_EMAIL,
    label: PLACEHOLDER_LABELS.BA_EMAIL,
    isSubHead: false,
  },
  {
    id: BA_PHONE,
    value: BA_PHONE,
    label: PLACEHOLDER_LABELS.BA_PHONE,
    isSubHead: false,
  },
  {
    id: BA_SIGNUP_DATE,
    value: BA_SIGNUP_DATE,
    label: PLACEHOLDER_LABELS.BA_SIGNUP_DATE,
    isSubHead: false,
  },
  {
    id: BA_ONBOARDING_DATE,
    value: BA_ONBOARDING_DATE,
    label: PLACEHOLDER_LABELS.BA_ONBOARDING_DATE,
    isSubHead: false,
  },
  {
    id: BA_ONBOARDING_TIME,
    value: BA_ONBOARDING_TIME,
    label: PLACEHOLDER_LABELS.BA_ONBOARDING_TIME,
    isSubHead: false,
  },
  {
    id: BA_STATUS,
    value: BA_STATUS,
    label: PLACEHOLDER_LABELS.BA_STATUS,
    isSubHead: false,
  },
  {
    id: BA_MERCHANDISE_HELD,
    value: BA_MERCHANDISE_HELD,
    label: PLACEHOLDER_LABELS.BA_MERCHANDISE_HELD,
    isSubHead: false,
  },
  {
    id: BA_MONEY_EARNED,
    value: BA_MONEY_EARNED,
    label: PLACEHOLDER_LABELS.BA_MONEY_EARNED,
    isSubHead: false,
  },
  {
    id: BA_BLOCKED_REASON,
    value: BA_BLOCKED_REASON,
    label: PLACEHOLDER_LABELS.BA_BLOCKED_REASON,
    isSubHead: false,
  },
].sort((a, b) => {
  if (a.label < b.label) {
    return -1
  }
  if (a.label > b.label) {
    return 1
  }
  return 0
})

const missionRelatedPlaceholders = [
  {
    id: BA_NEXT_MISSION_DATE,
    value: BA_NEXT_MISSION_DATE,
    label: PLACEHOLDER_LABELS.BA_NEXT_MISSION_DATE,
    isSubHead: false,
  },
  {
    id: BA_NEXT_MISSION_TIME,
    value: BA_NEXT_MISSION_TIME,
    label: PLACEHOLDER_LABELS.BA_NEXT_MISSION_TIME,
    isSubHead: false,
  },
  {
    id: BA_NEXT_MISSION_TYPE,
    value: BA_NEXT_MISSION_TYPE,
    label: PLACEHOLDER_LABELS.BA_NEXT_MISSION_TYPE,
    isSubHead: false,
  },
  {
    id: BA_NEXT_MISSION_LOCATION,
    value: BA_NEXT_MISSION_LOCATION,
    label: PLACEHOLDER_LABELS.BA_NEXT_MISSION_LOCATION,
    isSubHead: false,
  },
  {
    id: BA_NEXT_MISSION_CLIENT,
    value: BA_NEXT_MISSION_CLIENT,
    label: PLACEHOLDER_LABELS.BA_NEXT_MISSION_CLIENT,
    isSubHead: false,
  },
  {
    id: BA_NEXT_MISSION_PAY_RATIO,
    value: BA_NEXT_MISSION_PAY_RATIO,
    label: PLACEHOLDER_LABELS.BA_NEXT_MISSION_PAY_RATIO,
    isSubHead: false,
  },
  {
    id: BA_LAST_MISSION_DATE,
    value: BA_LAST_MISSION_DATE,
    label: PLACEHOLDER_LABELS.BA_LAST_MISSION_DATE,
    isSubHead: false,
  },
  {
    id: BA_LAST_MISSION_TIME,
    value: BA_LAST_MISSION_TIME,
    label: PLACEHOLDER_LABELS.BA_LAST_MISSION_TIME,
    isSubHead: false,
  },
  {
    id: BA_MISSION_MEETING_POINT_TIME,
    value: BA_MISSION_MEETING_POINT_TIME,
    label: PLACEHOLDER_LABELS.BA_MISSION_MEETING_POINT_TIME,
    isSubHead: false,
  },
  {
    id: BA_MISSION_MEETING_POINT_DATE,
    value: BA_MISSION_MEETING_POINT_DATE,
    label: PLACEHOLDER_LABELS.BA_MISSION_MEETING_POINT_DATE,
    isSubHead: false,
  },
  {
    id: BA_MISSION_MEETING_POINT_ADDRESS,
    value: BA_MISSION_MEETING_POINT_ADDRESS,
    label: PLACEHOLDER_LABELS.BA_MISSION_MEETING_POINT_ADDRESS,
    isSubHead: false,
  },
].sort((a, b) => {
  if (a.label < b.label) {
    return -1
  }
  if (a.label > b.label) {
    return 1
  }
  return 0
})

const cityRelatedPlaceholders = [
  {
    id: CITY_NAME,
    value: CITY_NAME,
    label: PLACEHOLDER_LABELS.CITY_NAME,
    isSubHead: false,
  },
  {
    id: CITY_PICKUP_LOCATION_LINK,
    value: CITY_PICKUP_LOCATION_LINK,
    label: PLACEHOLDER_LABELS.CITY_PICKUP_LOCATION_LINK,
    isSubHead: false,
  },
  {
    id: CITY_NEXT_PICKUP_DATE,
    value: CITY_NEXT_PICKUP_DATE,
    label: PLACEHOLDER_LABELS.CITY_NEXT_PICKUP_DATE,
    isSubHead: false,
  },
  {
    id: CITY_NEXT_PICKUP_TIME,
    value: CITY_NEXT_PICKUP_TIME,
    label: PLACEHOLDER_LABELS.CITY_NEXT_PICKUP_TIME,
    isSubHead: false,
  },
  {
    id: CITY_BAD_WEATHER_WEEK,
    value: CITY_BAD_WEATHER_WEEK,
    label: PLACEHOLDER_LABELS.CITY_BAD_WEATHER_WEEK,
    isSubHead: false,
  },
  {
    id: CITY_BAD_WEATHER_PAYOUT,
    value: CITY_BAD_WEATHER_PAYOUT,
    label: PLACEHOLDER_LABELS.CITY_BAD_WEATHER_PAYOUT,
    isSubHead: false,
  },
  {
    id: CITY_BAD_WEATHER_WEEK_TARGET,
    value: CITY_BAD_WEATHER_WEEK_TARGET,
    label: PLACEHOLDER_LABELS.CITY_BAD_WEATHER_WEEK_TARGET,
    isSubHead: false,
  },
  {
    id: CITY_BA_REFERRAL_START_DATE,
    value: CITY_BA_REFERRAL_START_DATE,
    label: PLACEHOLDER_LABELS.CITY_BA_REFERRAL_START_DATE,
    isSubHead: false,
  },
  {
    id: CITY_BA_REFERRAL_TRIGGER,
    value: CITY_BA_REFERRAL_TRIGGER,
    label: PLACEHOLDER_LABELS.CITY_BA_REFERRAL_TRIGGER,
    isSubHead: false,
  },
  {
    id: CITY_BA_REFERRAL_REWARD,
    value: CITY_BA_REFERRAL_REWARD,
    label: PLACEHOLDER_LABELS.CITY_BA_REFERRAL_REWARD,
    isSubHead: false,
  },
  {
    id: CITY_MISSION_AVAILABLE,
    value: CITY_MISSION_AVAILABLE,
    label: PLACEHOLDER_LABELS.CITY_MISSION_AVAILABLE,
    isSubHead: false,
  },
  {
    id: CITY_BA_ONBOARDING_LINK,
    value: CITY_BA_ONBOARDING_LINK,
    label: PLACEHOLDER_LABELS.CITY_BA_ONBOARDING_LINK,
    isSubHead: false,
  },
].sort((a, b) => {
  if (a.label < b.label) {
    return -1
  }
  if (a.label > b.label) {
    return 1
  }
  return 0
})

const deeplinks = [
  {
    id: DEEPLINK_ABN,
    value: DEEPLINK_ABN,
    label: PLACEHOLDER_LABELS.DEEPLINK_ABN,
    isSubHead: false,
  },
  {
    id: DEEPLINK_APP_UPDATE,
    value: DEEPLINK_APP_UPDATE,
    label: PLACEHOLDER_LABELS.DEEPLINK_APP_UPDATE,
    isSubHead: false,
  },
  {
    id: DEEPLINK_APP_STORE,
    value: DEEPLINK_APP_STORE,
    label: PLACEHOLDER_LABELS.DEEPLINK_APP_STORE,
    isSubHead: false,
  },
  {
    id: DEEPLINK_AVAILABILITY,
    value: DEEPLINK_AVAILABILITY,
    label: PLACEHOLDER_LABELS.DEEPLINK_AVAILABILITY,
    isSubHead: false,
  },
  {
    id: DEEPLINK_BANK_DETAILS,
    value: DEEPLINK_BANK_DETAILS,
    label: PLACEHOLDER_LABELS.DEEPLINK_BANK_DETAILS,
    isSubHead: false,
  },
  {
    id: DEEPLINK_BOOK_MISSION,
    value: DEEPLINK_BOOK_MISSION,
    label: PLACEHOLDER_LABELS.DEEPLINK_BOOK_MISSION,
    isSubHead: false,
  },
  {
    id: DEEPLINK_HOW_TO_GUIDE,
    value: DEEPLINK_HOW_TO_GUIDE,
    label: PLACEHOLDER_LABELS.DEEPLINK_HOW_TO_GUIDE,
    isSubHead: false,
  },
  {
    id: DEEPLINK_SET_BASES,
    value: DEEPLINK_SET_BASES,
    label: PLACEHOLDER_LABELS.DEEPLINK_SET_BASES,
    isSubHead: false,
  },
  {
    id: DEEPLINK_COMPLETED_MISSIONS,
    value: DEEPLINK_COMPLETED_MISSIONS,
    label: PLACEHOLDER_LABELS.DEEPLINK_COMPLETED_MISSIONS,
    isSubHead: false,
  },
  {
    id: DEEPLINK_CONTACT_DETAILS,
    value: DEEPLINK_CONTACT_DETAILS,
    label: PLACEHOLDER_LABELS.DEEPLINK_CONTACT_DETAILS,
    isSubHead: false,
  },
  {
    id: DEEPLINK_EARNINGS,
    value: DEEPLINK_EARNINGS,
    label: PLACEHOLDER_LABELS.DEEPLINK_EARNINGS,
    isSubHead: false,
  },
  {
    id: DEEPLINK_UPCOMING_MISSION,
    value: DEEPLINK_UPCOMING_MISSION,
    label: PLACEHOLDER_LABELS.DEEPLINK_UPCOMING_MISSION,
    isSubHead: false,
  },
  {
    id: DEEPLINK_MISSION_CHECKIN,
    value: DEEPLINK_MISSION_CHECKIN,
    label: PLACEHOLDER_LABELS.DEEPLINK_MISSION_CHECKIN,
    isSubHead: false,
  },
  {
    id: DEEPLINK_PAUSE_AVAILABILITY,
    value: DEEPLINK_PAUSE_AVAILABILITY,
    label: PLACEHOLDER_LABELS.DEEPLINK_PAUSE_AVAILABILITY,
    isSubHead: false,
  },
  {
    id: DEEPLINK_PRIVACY_POLICY,
    value: DEEPLINK_PRIVACY_POLICY,
    label: PLACEHOLDER_LABELS.DEEPLINK_PRIVACY_POLICY,
    isSubHead: false,
  },
  {
    id: DEEPLINK_SURGE_TIME,
    value: DEEPLINK_SURGE_TIME,
    label: PLACEHOLDER_LABELS.DEEPLINK_SURGE_TIME,
    isSubHead: false,
  },
  {
    id: DEEPLINK_TERMS_OF_SERVICE,
    value: DEEPLINK_TERMS_OF_SERVICE,
    label: PLACEHOLDER_LABELS.DEEPLINK_TERMS_OF_SERVICE,
    isSubHead: false,
  },
  {
    id: DEEPLINK_UPLOAD_PICTURE,
    value: DEEPLINK_UPLOAD_PICTURE,
    label: PLACEHOLDER_LABELS.DEEPLINK_UPLOAD_PICTURE,
    isSubHead: false,
  },

  {
    id: DEEPLINK_PICKUP_LOCATION,
    value: DEEPLINK_PICKUP_LOCATION,
    label: PLACEHOLDER_LABELS.DEEPLINK_PICKUP_LOCATION,
    isSubHead: false,
  },
  {
    id: DEEPLINK_PICKUP_TIME,
    value: DEEPLINK_PICKUP_TIME,
    label: PLACEHOLDER_LABELS.DEEPLINK_PICKUP_TIME,
    isSubHead: false,
  },
  {
    id: DEEPLINK_MISSION_LOCATION,
    value: DEEPLINK_MISSION_LOCATION,
    label: PLACEHOLDER_LABELS.DEEPLINK_MISSION_LOCATION,
    isSubHead: false,
  },
  {
    id: DEEPLINK_CLIENT_PITCH,
    value: DEEPLINK_CLIENT_PITCH,
    label: PLACEHOLDER_LABELS.DEEPLINK_CLIENT_PITCH,
    isSubHead: false,
  },
  {
    id: DEEPLINK_REFER_FRIEND,
    value: DEEPLINK_REFER_FRIEND,
    label: PLACEHOLDER_LABELS.DEEPLINK_REFER_FRIEND,
    isSubHead: false,
  },
  {
    id: DEEPLINK_PAYMENT_DATE,
    value: DEEPLINK_PAYMENT_DATE,
    label: PLACEHOLDER_LABELS.DEEPLINK_PAYMENT_DATE,
    isSubHead: false,
  },
  {
    id: DEEPLINK_PICKUP_SCANNER,
    value: DEEPLINK_PICKUP_SCANNER,
    label: PLACEHOLDER_LABELS.DEEPLINK_PICKUP_SCANNER,
    isSubHead: false,
  },
  {
    id: DEEPLINK_CHAT,
    value: DEEPLINK_CHAT,
    label: PLACEHOLDER_LABELS.DEEPLINK_CHAT,
    isSubHead: false,
  },
  {
    id: DEEPLINK_MY_MISSIONS,
    value: DEEPLINK_MY_MISSIONS,
    label: PLACEHOLDER_LABELS.DEEPLINK_MY_MISSIONS,
    isSubHead: false,
  },
  {
    id: DEEPLINK_BROWSE_MISSIONS_H2H,
    value: DEEPLINK_BROWSE_MISSIONS_H2H,
    label: PLACEHOLDER_LABELS.DEEPLINK_BROWSE_MISSIONS_H2H,
    isSubHead: false,
  },
  {
    id: DEEPLINK_BROWSE_MISSIONS_LTB,
    value: DEEPLINK_BROWSE_MISSIONS_LTB,
    label: PLACEHOLDER_LABELS.DEEPLINK_BROWSE_MISSIONS_LTB,
    isSubHead: false,
  },
  {
    id: DEEPLINK_MY_COMPLETED_MISSIONS,
    value: DEEPLINK_MY_COMPLETED_MISSIONS,
    label: PLACEHOLDER_LABELS.DEEPLINK_MY_COMPLETED_MISSIONS,
    isSubHead: false,
  },
  {
    id: DEEPLINK_REBOOK_ONBOARDING,
    value: DEEPLINK_REBOOK_ONBOARDING,
    label: PLACEHOLDER_LABELS.DEEPLINK_REBOOK_ONBOARDING,
    isSubHead: false,
  },
].sort((a, b) => {
  if (a.label < b.label) {
    return -1
  }
  if (a.label > b.label) {
    return 1
  }
  return 0
})

const optionsPlaceholder = [
  {
    id: 'BA related fields',
    value: 'BA related fields',
    label: 'BA related fields',
    isSubHead: true,
  },
  ...baRelatedPlaceholders,
  {
    id: 'Mission related fields',
    value: 'Mission related fields',
    label: 'Mission related fields',
    isSubHead: true,
  },
  ...missionRelatedPlaceholders,
  {
    id: 'City related Fields',
    value: 'City related Fields',
    label: 'City related Fields',
    isSubHead: true,
  },
  ...cityRelatedPlaceholders,
  {
    id: 'Deeplinks',
    value: 'Deeplinks',
    label: 'Deeplinks',
    isSubHead: true,
  },
  ...deeplinks,
]

const optionsPlaceholderWithoutDeeplinks = [
  {
    id: 'BA related fields',
    value: 'BA related fields',
    label: 'BA related fields',
    isSubHead: true,
  },
  ...baRelatedPlaceholders,
  {
    id: 'Mission related fields',
    value: 'Mission related fields',
    label: 'Mission related fields',
    isSubHead: true,
  },
  ...missionRelatedPlaceholders,
  {
    id: 'City related Fields',
    value: 'City related Fields',
    label: 'City related Fields',
    isSubHead: true,
  },
  ...cityRelatedPlaceholders,
]

const emailOptions = [
  { id: 1, label: 'miami1@oppizi.com', value: 'miami1@oppizi.com' },
  { id: 2, label: 'miami2@oppizi.com', value: 'miami2@oppizi.com' },
  { id: 3, label: 'miami3@oppizi.com', value: 'miami3@oppizi.com' },
]

const comparisonMap = {
  null: { value: '-', label: 'none' },
  EQUALS: { value: '=', label: 'equal to' },
  NOT_EQUALS: { value: '≠', label: 'not equal to' },
  LESS_THAN: { value: '<', label: 'less than' },
  LESS_THAN_EQUALS: { value: '≤', label: 'less or equal' },
  GREATER_THAN: { value: '>', label: 'greater than' },
  GREATER_THAN_EQUALS: { value: '≥', label: 'greater or equal' },
}

const smallerComparisonMap = {
  null: { value: '-', label: 'none' },
  EQUALS: { value: '=', label: 'equal to' },
  GREATER_THAN_EQUALS: { value: '≥', label: 'greater or equal' },
}

const DEFAULT_VALUES_PLACEHOLDER = {
  PLACEHOLDER: 'PLACEHOLDER',
  NONE: 'NONE',
}

const dayTriggerOption = [
  { id: 1, label: 'day', value: 'day' },
  { id: 2, label: 'hour', value: 'hour' },
  { id: 3, label: 'min', value: 'min' },
]

const triggerOrderOption = [
  { id: 1, label: 'after', value: 'after' },
  { id: 2, label: 'before', value: 'before' },
]

const triggerChoseOption = [
  { id: 1, label: 'trigger', value: 'trigger' },
  { id: 2, label: 'Last email', value: 'Last email' },
]

export {
  PIPELINE_STAGE_ENUM,
  PIPELINE_EMAILS_STEPS_ENUM,
  mocRowsEnrolments,
  mocRowsSequence,
  headersEnrollments,
  headersSequence,
  headersCommunications,
  stagesMapper,
  optionsStages,
  optionsStatuses,
  optionsGroupBy,
  optionsTriggers,
  optionsPlaceholder,
  optionsPlaceholderWithoutDeeplinks,
  optionsRedirection,
  emailOptions,
  comparisonMap,
  DEFAULT_VALUES_PLACEHOLDER,
  dayTriggerOption,
  triggerOrderOption,
  triggerChoseOption,
  conditionalTriggers,
  scheduledTriggers,
  smallerComparisonMap,
  communicationsOptions,
  sequencesSourceOptions,
  sequencesTypeOptions,
}
